import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from "dompurify";
import { useConsent } from "../hooks/useConsent";
import { phoneCode } from "./phoneCode";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getSanitizedHtmlString(html) {
  return DOMPurify.sanitize(html);
}

export function formattedPhone(phone, countryCode) {
  let formattedPhone = phone;

  if (countryCode === "TR") {
    // "(123) 456 7890" -> "1234567890"
    formattedPhone = phone.replace(/\D/g, "");
    formattedPhone = `+90${formattedPhone}`;
  } else {
    // Zaten 13 haneli rakam geliyor
    formattedPhone = `+49${formattedPhone}`;
  }
  return formattedPhone;
}

export function getConsentInfo(type) {
  const { data, isLoading } = useConsent(type);
  let result = {
    text: "",
    typeID: 0,
    version: "",
  };
  if (!isLoading & (data !== undefined) & (data !== null)) {
    if (data.items) {
      result = {
        text: data.items[0].text,
        typeID: data.items[0].consentType,
        version: data.version,
      };
    }
  }
  return result;
}

export const getCountryCode = () => {
  return localStorage.getItem("countryCode")?.toUpperCase() || "TR";
};

export const getMailToByCountry = (countryCode) => {
  return countryCode === "DE"
    ? "mailto:direkt-vertrieb@vestel-germany.de"
    : "mailto:akillidunyam@vestel.com.tr";
};

export const attrArrayToMap = (attrArray) => {
  return Object.fromEntries(attrArray.map((item) => [item.Name, item.Value]));
};

export function getLocalPhoneNumber(attrMap, countryCode) {
  const rawPhone = attrMap["phone_number"] || "";
  let phone_number = rawPhone;

  const phonePrefix = phoneCode.find(
    (item) => item.code === countryCode
  )?.dial_code;

  if (rawPhone.startsWith(phonePrefix)) {
    phone_number = rawPhone.slice(phonePrefix.length);
  }

  return phone_number;
}
